import { createSelector } from 'reselect'

import { RootState } from '../../core/store/root.reducer'

const getBrand = (state: RootState) => state.brand

export const selectBrand = createSelector(getBrand, (brand) => brand)

export default selectBrand
